
import React, { Fragment, useState, useEffect, useContext } from 'react'
import { Link, Redirect } from 'react-router-dom'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import { Helmet } from "react-helmet-async"
import Header from './Header'
import Footer from './Footer'
import AppContext from '../contexts/AppContext'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

const PromoProcess = ({ history, match }) => {

    const { key } = match.params
    const { data, authServices, setAppState } = useContext(AppContext)
    const { app, isReady } = data

    const redirect_path = window.location.hash ? window.location.hash.substring(1) : ''

    useEffect(() => {
        if(isReady){
            setAppState('app.promo_code', key)
            authServices.usePromo(key).then(res => {
                if(res && res.redirect_to){
                    window.location.href = res.redirect_to + redirect_path
                }else{
                    window.location.href = redirect_path ? redirect_path : '/'
                }
            }).catch(res => {
                if(res && res.data && res.data.redirect_to){
                    window.location.href = res.data.redirect_to + redirect_path
                }else{
                    window.location.href = redirect_path ? redirect_path : '/'
                }
            })
        }
    }, [isReady])

    return (
        <Fragment>
            <Header history={history} />
            <main className="py-4">
                <div className="container">
                    <div className="my-5 text-center">
                        <FontAwesomeIcon icon={faSpinner} spin  />
                    </div>
                </div>
            </main>
            <Footer />
        </Fragment>
    )
}

export default PromoProcess
